import { render, staticRenderFns } from "./errGeneral.vue?vue&type=template&id=f3e4c2da"
import script from "./errGeneral.vue?vue&type=script&lang=js"
export * from "./errGeneral.vue?vue&type=script&lang=js"
import style0 from "./errGeneral.vue?vue&type=style&index=0&id=f3e4c2da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports